export const ALL_COMPANY_REVIEW_SUMMARY = "ALL_COMPANY_REVIEW_SUMMARY";

const initialState = null; 

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ALL_COMPANY_REVIEW_SUMMARY:
            return action.payload;
        default:
            return state;
    }
}

const storeName = "allCompanyReviewSummary";

const storeMapping = {[storeName]: reducer};

export const allCompanyReviewSummarySelector = (state) => state[storeName];

export default storeMapping;
